import type { Brand } from "@health/types";
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

export function useCategoryTransition(brand: Brand) {
  const navigate = useNavigate();
  return useCallback(
    (event: { toolName: string; args: Record<string, unknown> }) => {
      if (event.toolName === "switch_category" && event.args.category) {
        navigate({
          to: "/$brand/$cat",
          params: { brand, cat: event.args.category as string },
          search: { from: "chat" },
        });
      }
    },
    [brand, navigate],
  );
}
